import {fileExtension} from "../constants/regexPatterns";

export const getFileExtension = (fileName : string) : string =>
    fileName.match(fileExtension)?.[0] || ""; 